
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prosjekter",
      function () {
        return require("private-next-pages/prosjekter.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prosjekter"])
      });
    }
  